import { IVersionProperty } from '@domain/creativeset/version';
import { IFeed, IFeedStep } from '@domain/feed';
import Ajv from 'ajv/dist/jtd';
import {
    ensureEnumOrDefault,
    ensureNumberOrDefault,
    ensureStringOrDefault
} from '../serialization.utils';
import { feedSchema } from './version-schemas';

const ajv = new Ajv();

export function serializeVersionedFeed({ value }: IVersionProperty<IFeed>): string {
    return serializeVersionedFeedValue(value);
}

export function serializeVersionedFeedValue(value: IFeed): string {
    const serialize = ajv.compileSerializer(feedSchema);

    const validFeed: IFeed = {
        id: ensureStringOrDefault(value['id']),
        path: ensureStringOrDefault(value['path']),
        fallback: ensureStringOrDefault(value['fallback']),
        type: 'text',
        step: {
            size: ensureNumberOrDefault(value['step']?.['size']),
            start: ensureNumberOrDefault(value['step']?.['start']),
            occurrence: ensureEnumOrDefault<IFeedStep['occurrence']>(value['step']?.['occurrence'], [
                'loop',
                'none'
            ])
        }
    };
    return serialize(validFeed);
}
